import * as pdfjsLib from 'pdfjs-dist';

// Define o worker da versão compatível que você instalou
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.14.305/pdf.worker.min.js';

let currentPdfBlob = null;

function setupPdfModalButtons() {
  const downloadBtn = document.getElementById('btnDownloadPdf');
  if (downloadBtn) {
    downloadBtn.onclick = function () {
      if (!currentPdfBlob) return alert('PDF não carregado');
      const url = URL.createObjectURL(currentPdfBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = document.getElementById('modalPdfTitle').textContent;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    };
  }

  // Botão de compartilhar
  const shareBtn = document.getElementById('btnSharePdf');
  if (shareBtn) {
    shareBtn.onclick = async function () {
      if (!currentPdfBlob) return alert('PDF não carregado');

      const filename = document.getElementById('modalPdfTitle').textContent || 'documento.pdf';
      const file = new File([currentPdfBlob], filename, { type: 'application/pdf' });

      if (!navigator.canShare || !navigator.canShare({ files: [file] })) {
        return alert('Compartilhamento de arquivos não suportado neste dispositivo.');
      }

      try {
        await navigator.share({
          title: `Documento: ${filename}`,
          text: `Segue o documento ${filename}.`,
          files: [file],
        });
      } catch (err) {
        if (err.name === 'AbortError' || err.message === 'Share canceled') {
          console.log('Compartilhamento cancelado pelo usuário.');
        } else {
          console.error('Erro ao compartilhar:', err);
          alert('Erro ao compartilhar: ' + err.message);
        }
      }
    };
  }

}

window.abrirModalPdf = async function (url) {
  try {
    // Atualiza título para mostrar "Carregando..." e abre a modal imediatamente
    document.getElementById('modalPdfTitle').textContent = 'Carregando PDF...';
    $('#modalPdf').modal('show');

    // Limpa canvas ou mostra um texto de carregamento na modal
    const canvas = document.getElementById('pdfCanvas');
    const context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = '20px Arial';
    context.fillText('Carregando PDF...', 10, 50);

    const response = await fetch(url);
    if (!response.ok) throw new Error('Erro ao buscar PDF');
    const data = await response.json();

    const byteCharacters = atob(data.pdf_base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    currentPdfBlob = new Blob([byteArray], { type: 'application/pdf' });

    document.getElementById('modalPdfTitle').textContent = data.filename;

    const loadingTask = pdfjsLib.getDocument(URL.createObjectURL(currentPdfBlob));
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);
    const scale = 1.5;
    const viewport = page.getViewport({ scale });

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    context.clearRect(0, 0, canvas.width, canvas.height);

    await page.render({ canvasContext: context, viewport }).promise;

    setupPdfModalButtons();
  } catch (error) {
    alert('Erro ao carregar PDF: ' + error.message);
    console.error(error);
  }
};